import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

class PostListing extends Component {
  getPostList() {
    const postList = []
    this.props.postEdges.forEach(postEdge => {
      if (postEdge.node.frontmatter.type === 'page') {
        return
      }
      postList.push({
        path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        cover: postEdge.node.frontmatter.cover,
        title: postEdge.node.frontmatter.title,
        category: postEdge.node.frontmatter.category,
        date: postEdge.node.frontmatter.date,
        month: postEdge.node.frontmatter.month,
        year: postEdge.node.frontmatter.year,
        author: postEdge.node.frontmatter.author,
        excerpt: postEdge.node.excerpt,
        timeToRead: postEdge.node.timeToRead,
        description: postEdge.node.frontmatter.description,
        external: postEdge.node.frontmatter.external,
        id: postEdge.node.id
      })
    })

    const postItems = []
    postList.forEach(post => {
      if (post.external) {
        postItems.push(
          <PostItem key={post.id}>
            <a href={post.external}>
              <CoverImage img={post.cover} className="postCover" />
              <div className="PostItem__PostMeta">
                <p>
                  {post.month} {post.year} by {post.author} in {post.category}
                </p>
              </div>
              <div className="PostItem--PostContent">
                <h2>{post.title}</h2>
                <p>{post.description}</p>
              </div>
            </a>
          </PostItem>
        )
      } else {
        postItems.push(
          <PostItem key={post.id}>
            <Link to={post.path}>
              <CoverImage img={post.cover} className="postCover" />
              <div className="PostItem__PostMeta">
                <p>
                  {post.month} {post.year} by {post.author} in {post.category}
                </p>
              </div>
              <div className="PostItem--PostContent">
                <h2>{post.title}</h2>
                <p>{post.description}</p>
              </div>
            </Link>
          </PostItem>
        )
      }
    })
    return postItems
  }

  render() {
    const postList = this.getPostList()
    return (
      <PostListingContainer>
        <ul className="PostListing">
          {postList.map(post => <li key={Math.random()}>{post}</li>)}
        </ul>
      </PostListingContainer>
    )
  }
}

export default PostListing

const PostListingContainer = styled.div`
  width: 600px;
  margin: auto;

  @media screen and (max-width: 768px) {
    width: 90%;
    margin-bottom: 50px;
  }
`

const CoverImage = styled.div`
  width: 600px;
  height: 200px;
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: center;
  @media screen and (max-width: 768px) {
    display: none;
  }
`

const PostItem = styled.div`
  margin: 50px 0;

  @media screen and (max-width: 768px) {
    margin: 50px auto;

    .PostItem--PostContent > h2 {
      font-size: 2.2rem;
    }
  }

  .PostItem__PostMeta {
    position: relative;
    padding: 5px 15px;
    top: -15px;
    left: 5px;
    width: 90%;
    background: #171717;
  }

  .PostItem__PostMeta,
  .PostItem__PostMeta > p {
    color: white;
    font-family: Consolas, Menlo, Monaco, Andale Mono WT, Andale Mono,
      Lucida Console, Lucida Sans Typewriter, DejaVu Sans Mono,
      Bitstream Vera Sans Mono, Liberation Mono, Nimbus Mono L, Courier New,
      Courier, monospace, monospace;
    font-size: 1.3rem;
  }

  .PostItem--PostContent * {
    transition: all 0.3s ease;
  }

  &:hover {
    .PostItem--PostContent * {
      color: #43ab60;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/PostListing/PostListing.jsx